export default __webpack_public_path__ + "static/media/img-slider-cmbus-admin-1.2e61a16b.png";